import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useLanguage } from '../../LanguageProvider';
import { getPaymentStatus } from '../../services/PaymentService';
import './PaymentConfirmation.scss';

const PaymentConfirmation = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  
  // Try multiple possible parameter names
  const orderId = searchParams.get('order_id') || 
                  searchParams.get('klarna_order_id') || 
                  searchParams.get('checkout.order.id');
  
  console.log("Order ID from query params:", orderId);
  console.log("Full query string:", location.search);

  //const { orderId } = useParams();
  const navigate = useNavigate();
  const { languageData } = useLanguage();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [klarnaContainer, setKlarnaContainer] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    if (!orderId) {
      navigate('/participants');
      return;
    }

    const loadConfirmationPage = async () => {
      try {
        setLoading(true);
        
        // Get payment status from Klarna
        const response = await getPaymentStatus(orderId);
        
        // Set status based on Klarna response
        if (response.status === 'COMPLETED') {
          setPaymentStatus('success');
        } else {
          setPaymentStatus('pending');
        }
        
        // Set Klarna confirmation HTML if available
        if (response.html_snippet) {
          setKlarnaContainer(response.html_snippet);
        }
        
        setLoading(false);
      } catch (err) {
        console.error('Payment confirmation error:', err);
        setError(languageData.payment.confirmationError);
        setLoading(false);
      }
    };

    loadConfirmationPage();
  }, [orderId, navigate, languageData]);
  
  // Render Klarna container after it's loaded
  useEffect(() => {
    if (klarnaContainer) {
      // Create a container for Klarna checkout and inject the HTML
      const container = document.getElementById('klarna-confirmation-container');
      if (container) {
        container.innerHTML = klarnaContainer;
      }
    }
  }, [klarnaContainer]);

  return (
    <>
      <Helmet>
        <title>
          {languageData.payment.confirmationTitle} - Unterberg Duathlon 2027
        </title>
        <meta
          name="description"
          content={languageData.payment.confirmationMetaDescription}
        />
      </Helmet>
      <div className="payment-confirmation">
        <div className="payment-confirmation__container">
          <h2 className="payment-confirmation__title">
            {languageData.payment.confirmationTitle}
          </h2>
          
          {loading ? (
            <div className="payment-confirmation__loading">
              <p>{languageData.payment.loading}</p>
            </div>
          ) : error ? (
            <div className="payment-confirmation__error">
              <p>{error}</p>
              <button 
                onClick={() => navigate('/participants')} 
                className="payment-confirmation__btn"
              >
                {languageData.payment.backToParticipants}
              </button>
            </div>
          ) : (
            <>
              <div className={`payment-confirmation__status payment-confirmation__status--${paymentStatus}`}>
                {paymentStatus === 'success' ? (
                  <p>{languageData.payment.successMessage}</p>
                ) : (
                  <p>{languageData.payment.pendingMessage}</p>
                )}
              </div>
              
              {klarnaContainer && (
                <div 
                  id="klarna-confirmation-container" 
                  className="payment-confirmation__klarna-container"
                ></div>
              )}
              
              <div className="payment-confirmation__actions">
                <button 
                  onClick={() => navigate('/participants')} 
                  className="payment-confirmation__btn"
                >
                  {languageData.payment.viewParticipants}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PaymentConfirmation;